<template>
  <div class="wrapper">
    <b-container id="login">
      <b-form class="login-form" @submit.prevent="onSubmit">
        <div class="form-item form-img">
          <img
            src="@/assets/logo.svg"
            alt=""
            style="width: 250px; height: 32px"
          />
        </div>
        <div class="form-item" style="margin-top: 32px; position: relative">
          <label for="username">{{ fieldLabel }}:</label>
          <input
            type="text"
            class="form-control"
            v-model="username"
            :placeholder="fieldPlaceholder"
            autofocus
            required
          />
          <div
            class="type-switch"
            style="margin-top: 8px; display: flex; gap: 16px"
          >
            <label
              style="
                display: flex;
                align-items: center;
                gap: 6px;
                cursor: pointer;
                font-size: smaller;
              "
            >
              <input
                type="radio"
                value="phone"
                v-model="type"
                style="width: 20px"
              />
              Утасны дугаараар
            </label>
            <label
              style="
                display: flex;
                align-items: center;
                gap: 6px;
                cursor: pointer;
                font-size: smaller;
              "
            >
              <input
                type="radio"
                value="cardId"
                v-model="type"
                style="width: 20px"
              />
              Картын дугаараар
            </label>
          </div>
        </div>
        <div class="form-item">
          <label for="">Нууц үг:</label>
          <input
            type="password"
            class="form-control"
            v-model="password"
            required
          />
        </div>
        <div class="form-item">
          <input
            type="submit"
            class="btn login-btn"
            value="Нэвтрэх"
            :disabled="isDisabled"
          />
        </div>
        <div class="form-item imgStyle" style="margin-top: 10px">
          <!-- <a
              href="https://card.nomin.mn/index.php/user"
              target="_blank"
              class="btnStyle02"
            >
              Шинээр бүртгүүлэх
            </a> -->

          <router-link class="btnStyle02" to="/card-register"
            >Шинээр бүртгүүлэх</router-link
          >

          <button type="button" @click="loginUpoint()">
            <img src="@/assets/upoint.png" alt="" width="24" />
            Нэвтрэх
          </button>
        </div>
        <div class="form-item form-last-text buttonStyle">
          <div style="margin: 0; padding: 0; margin-top: -7px">
            <b-button v-b-modal.modal-1>Тусламж</b-button>
            <b-modal
              id="modal-1"
              title="Тусламж хэсэг"
              hide-footer="{true}"
              size="xl"
              scrollable
            >
              <div class="helpStyle">
                <h2>1. Та анх удаа нэвтрэлт хийх гэж байгаа бол?</h2>
                <ul>
                  <li>Нэвтрэх нэр: Үндсэн утасны дугаар, картын дугаар</li>
                  <li>
                    Нууц үг: Үндсэн утасны дугаарт ирсэн гүйлгээний нууц үгээрээ
                    эхний удаа нэвтрэлт хийнэ.
                  </li>
                  <li>
                    Та нэвтэрч ороод нэвтрэх нууц үгээ солих шаардлагатайг
                    анхаарна
                  </li>
                </ul>
              </div>

              <div class="helpStyle">
                <h2>2. Нэвтрэх нууц үгээ хэрхэн солих вэ?</h2>
                <ul>
                  <li>
                    bonus.nomin.mn профайл > Нэвтрэх нууц үг солих хэсэг хуучин
                    нууц үг болон шинэ нууц үгээ оруулан солино уу
                  </li>
                  <li>
                    eNomin апплейкшний профайл > Нэвтрэх нууц үг солих хэсэг
                    хуучин нууц үг болон шинэ нууц үгээ оруулан солино у
                  </li>
                </ul>
              </div>

              <div class="helpStyle">
                <h2>3. Гүйлгээний пин код хэрхэн солих вэ?</h2>
                <ul>
                  <li>
                    bonus.nomin.mn профайл > Гүйлгээний пин код солих хэсэгт
                    шинэ пин кодоо оруулах > үндсэн утасны дугаар баталгаажуулна
                  </li>
                  <li>
                    eNomin апплейкшний профайл > Гүйлгээний пин код солих хэсэгт
                    шинэ пин кодоо оруулах > үндсэн утасны дугаар баталгаажуу
                  </li>
                  <li>
                    Өөрт ойр салбар дэлгүүрийн ахлах касс, кассад хандан үндсэн
                    утасны дугаараар авах
                  </li>
                  <li>132888 дугаарт PIN/ПИН гэж илгээн пин кодоо</li>
                  <li>
                    1800-2888 дугаарт холбогдон үндсэн утасны дугаартаа шинэ пин
                    код мессежээр авах
                  </li>
                </ul>
              </div>

              <div class="helpStyle">
                <h2>
                  4. Бонус цуглуулах эрхтэй картыг хэрхэн ашиглах эрхтэй карт
                  болгох вэ?
                </h2>
                <ul>
                  <li>
                    Та bonus.nomin.mn болон eNomin-д нэвтрэн үйлчилгээний гэрээ
                    хийж баталгаажуулж, мэдээллээ үнэн зөв бөглөж зарцуулах
                    эрхтэй болно.
                  </li>
                  <li>
                    Картын ажилтан дээр очин та үйлчилгээний гэрээ хийж,
                    мэдээллээ үнэн зөв бөглөснөөр таны карт зарцуулах эрхт
                  </li>
                </ul>
              </div>

              <div class="helpStyle">
                <h2>5. Хэрхэн бонус шилжүүлэх вэ</h2>
                <ul>
                  <li>
                    www.bonus.nomin.mn веб > Бонус шилжүүлэг > Хүлээн авагчийн
                    картын дугаар, үндсэн утасны дугаар > Шилжүүлэх дүн >
                    Гүйлгээний утга оруулан шилжүүлнэ.
                  </li>
                  <li>
                    eNomin апплейкшний > Бонус шилжүүлэг > Хүлээн авагчийн
                    картын дугаар, үндсэн утасны дугаар > Шилжүүлэх дүн >
                    Гүйлгээний утга оруулан шилжүүлнэ.
                  </li>
                  <li>
                    OmniWay апплейкшний >Бонус шилжүүлэг > Хүлээн авагчийн
                    картын дугаар, үндсэн утасны дугаар > Шилжүүлэх дүн >
                    Гүйлгээний утга оруулан шилжүүлнэ
                  </li>
                </ul>
              </div>

              <div class="helpStyle">
                <h2>6. Гэр бүлийн карт гэж юу вэ?</h2>
                <ul>
                  <li>
                    Нэг картыг 3 хүртэлх гэр бүлийн гишүүд дундаа ашиглаж болох
                    ба гэр бүлийн гишүүнтэйгээ нэг данстай болж нийт худалдан
                    авалт болон картын урамшууллын %-аа нэг дансанд төвлөрүүлж,
                    гишүүн бүр урамшууллыг ашиглах боломжтой үйлчилгээ юм
                  </li>
                </ul>
              </div>
            </b-modal>
          </div>
          <router-link to="/forget">Нууц үг мартсан ?</router-link>
        </div>
        <div class="form-item form-center-text">
          <router-link to="/business">Бизнес карт бүртгэх</router-link>
        </div>
        <div class="form-item form-last-text">
          <span>Лавлах утас: 1800-2888</span>
        </div>
        <div class="form-item form-error-out" v-if="error">
          <div class="form-error">
            <div class="error-icon">
              <img src="@/assets/icon/error.png" alt="" />
            </div>
            <div class="error-message">
              <p v-html="errorMessage"></p>
            </div>
          </div>
        </div>
        <div class="form-item form-error-out" v-if="globalError">
          <div class="form-error">
            <div class="error-icon">
              <img src="@/assets/icon/error.png" alt="" />
            </div>
            <div class="error-message">
              <p v-html="globalErrorMessage"></p>
            </div>
          </div>
        </div>
      </b-form>
    </b-container>
  </div>
</template>

<script>
import EventBus from "@/EventBus.js";
import Vue from "vue";

export default {
  name: "login",

  data() {
    return {
      username: "",
      password: "",
      error: false,
      uerror: false,
      isDisabled: false,
      errorMessage: "",
      type: "phone",
      deviceId: "",
    };
  },

  computed: {
    fieldLabel() {
      return this.type === "cardId" ? "Картын дугаар" : "Утасны дугаар";
    },

    fieldPlaceholder() {
      return this.type === "cardId" ? "Картын дугаар" : "Утасны дугаар";
    },
  },

  methods: {
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);

      if (parts.length === 2) {
        return parts.pop().split(";").shift();
      }

      return null;
    },

    setCookie(name, value, maxAgeSeconds) {
      const secure = window.location.protocol === "https:" ? "; Secure" : "";

      document.cookie =
        `${name}=${value}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax${secure}`;
    },

    getDeviceId() {
      let deviceId = this.getCookie("device_id");

      if (!deviceId) {
        if (window.crypto && window.crypto.randomUUID) {
          deviceId = window.crypto.randomUUID();
        } else {
          deviceId = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
            (
              c ^
              (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
            ).toString(16)
          );
        }

        this.setCookie("device_id", deviceId, 60 * 60 * 24 * 365);
      }

      return deviceId;
    },

    loginUpoint() {
      var state = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );

      window.location =
        "https://auth.upoint.mn/authorize?client_id=gOrI2KROrr6Csv&response_type=code&response_mode=query&scope=openid&redirect_uri=https://bonus.nomin.mn/upoint&state=" +
        state;
    },

    async onSubmit() {
      this.isDisabled = true;
      this.error = false;
      this.errorMessage = "";

      var username = this.username;
      var isnum = /^\d+$/.test(username);

      if (!isnum) {
        Vue.prototype.globalError = false;
        this.error = true;
        this.errorMessage = "Та зөвхөн тоо оруулна уу ?";
        this.isDisabled = false;
        return;
      }

      var name = this.username.replace(/\s/g, "");
      var pass = this.password.replace(/\s/g, "");

      if (name.length <= 0 || pass.length <= 0) {
        Vue.prototype.globalError = false;
        this.error = true;
        this.errorMessage = "Нэвтрэх нэр болон нууц үгээ оруулна уу";
        this.isDisabled = false;
        return;
      }

      this.$insProgress.start();

      this.$cardApi
        .post(
          // "/auth/bonus/card",
          "/auth/bonus/login",
          {
            cardNumber: this.username,
            password: this.password,
            type: this.type,
            systemId: "BonusWeb",
            deviceId: this.getDeviceId(),
          },
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          const data = response.data;
          if (data.status === 1 && data.otpRequired === 1) {
            const otpLoginPayload = {
              username: this.username,
              password: this.password,
              type: this.type,
              systemId: "BonusWeb",
              deviceId: this.getDeviceId(),
              cardHolderInfId: data.cardHolderInfId || "",
              keyInfId: data.keyInfId || "",
            };

            sessionStorage.setItem(
              "otpLoginPayload",
              JSON.stringify(otpLoginPayload)
            );

            const savedPayload = JSON.parse(
              sessionStorage.getItem("otpLoginPayload") || "{}"
            );

            if (
              !savedPayload.username ||
              !savedPayload.password 
            ) {
              this.isDisabled = false;
              Vue.prototype.globalError = false;
              this.error = true;
              this.errorMessage = "OTP мэдээлэл хадгалахад алдаа гарлаа";
              this.$insProgress.finish();
              return;
            }

            this.isDisabled = false;
            this.$insProgress.finish();
            this.$router.push({ path: "/otp" });
            return;
          }

          if (data.status === 0) {
            this.$auth.setToken(data.token);
            this.$auth.setMe(data);

            this.$bonusApi
              .post(
                `bonus-card/info/token`,
                {
                  tokenId: data.token,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    "Accept-Language": "mn",
                  },
                }
              )
              .then((response) => {
                var result = response.data;

                this.$auth.removeCardInfo();
                this.$auth.setCardInfo(response.data);

                if (result.status === 0) {
                  this.$router.push({ name: "homeDashboard" });
                } else if (result.status === 201) {
                  this.$auth.destroyToken();
                  this.$auth.removeMe();
                  this.$router.push({ name: "login" });
                }
              })
              .catch(() => {
                this.$auth.destroyToken();
                this.$auth.removeMe();
                this.$router.push({ name: "login" });
              });

            this.$insProgress.finish();
          } else if (data.status === 1) {
            this.isDisabled = false;
            Vue.prototype.globalError = false;
            this.errorMessage = data.message;
            this.error = true;
            this.$insProgress.finish();
          }
        })
        .catch((error) => {
          this.errorMessage = error;
          this.isDisabled = false;
          Vue.prototype.globalError = false;
          this.$insProgress.finish();
        });
    },

    setRedirectError(message, type) {
      this.error = type;
      this.errorMessage = message;
    },
  },

  created() {
  EventBus.$on("GLOBAL_ERROR", (data) => {
    if (data === "error") {
      Vue.prototype.globalError = true;
    }
  });

  this.username = this.$route.params.id;

  this.deviceId = this.getDeviceId();

  if (this.$auth.loggedIn()) {
    this.$router.push("profile");
  }
},
};
</script>
<style>
@import "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&amp;subset=cyrillic,cyrillic-ext";
.type-switch {
  font-size: 10px;
}
.wrapper {
  background-image: linear-gradient(
    to bottom,
    #5192d4,
    #4984c6,
    #4275b8,
    #3b68a9,
    #345a9b
  );
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.registerurl {
  text-align: left !important;
}
.none {
  display: none;
}
#login {
  height: 100%;
  width: 396px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-form {
  padding-left: 58px;
  padding-right: 58px;
  height: 541px;
  width: 396px;
  border-radius: 10px;
  box-shadow: 0px 25px 59px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}
.form-item label {
  width: 100%;
  height: auto;
  font-family: "Roboto";
  font-size: 11px;
  margin-bottom: 13px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.3px;
  margin: 0;
  text-align: left;
  color: #000000;
  text-transform: uppercase;
}
.form-item input {
  height: 36px;
  border-radius: 5px;
  font-size: 13px;
  width: 280px;
  background-color: #f5f5f5;
}
.form-item input::placeholder {
  opacity: 0.5;
  font-family: "Roboto";
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(0, 0, 0, 0.5);
}
.form-item.btnstyle input {
  width: 215px;
}
.btnstyle input::placeholder {
  font-size: 14px;
}
.form-item input::-moz-placeholder {
  opacity: 0.5;
  font-family: "Roboto";
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(0, 0, 0, 0.5);
}
.form-img {
  margin-top: 65px;
  display: flex;
  height: 49px;
}
.form-img img {
  margin: auto;
  height: auto;
}
.form-item input[type="submit"] {
  margin-top: 38px;
}
.form-item.marginTop10 input[type="submit"] {
  margin-top: 10px;
}
.form-item .upoint-span {
  color: #1660ab;
}
.form-item .login-btn {
  border-radius: 5px;
  background-color: #1660ab;
  font-family: "Roboto";
  font-size: 13px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.3px;
  text-align: center;
  color: #ffffff;
  text-transform: uppercase;
}
.form-last-text {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 17px;
}
.form-last-text span,
a {
  flex: 1;
  font-family: "Roboto";
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
.form-last-text a {
  text-align: right;
  color: #1660ab;
  cursor: pointer;
  text-decoration: none;
}

.form-center-text a {
  text-align: center;
  color: #1660ab;
  cursor: pointer;
  text-decoration: none;
}

.form-error {
  width: 100%;
  height: auto;
  border-radius: 5px;
  background-color: #fffafa;
  border: 1px solid #f8c3c5;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
}
.form-error .error-icon {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.form-error .error-message {
  flex: 6;
}
.form-error p {
  margin: 0;
  padding: 17px 21px 17px 12px;
  font-family: "Roboto";
  font-size: 11px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}
.form-error i {
  width: 16px;
  height: 14px;
  color: #ed3237;
}

.btnStyle02 {
  border-radius: 5px;
  background-color: #f7941d;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.3px;
  text-align: center;
  color: #ffffff;
  text-transform: uppercase;
  padding: 9px 7px;
}
.btnStyle02:hover {
  background: #000;
}
.btnStyle02 a {
  text-transform: uppercase;
  font-family: "Roboto";
  font-size: 13px;
  color: #fff;
}
.btnStyle02 a:hover {
  color: #fff;
}
.error-enter-active,
.error-leave-active {
  transition: all 0.5s ease-in;
}
.error-enter, .error-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
@media only screen and (max-width: 400px) {
  .login-form {
    width: 300px;
    padding-left: 25px !important;
    padding-right: 25px !important;
  }
  .form-item input {
    width: 100%;
  }
  .form-last-text {
    flex-direction: column;
  }
  .form-last-text a {
    text-align: left;
  }
}

/* error */
.username-error {
  position: absolute;
  float: left;
  color: #f05559;
  font-size: 12px;
  transition: all 0.3s ease-in;
}
.form-error-out {
  margin-top: 20px;
  margin-bottom: 20px;
}
.helpStyle {
  padding: 0;
  margin: 0;
}
.helpStyle h2 {
  background: #1660ab;
  color: #fff;
  width: 100%;
  font-size: 16px;
  padding: 10px;
}
.buttonStyle button {
  background: none !important;
  padding: 0;
  border: none;
  font-size: 11px;
  color: #1660ab;
}
.buttonStyle button:hover {
  color: #000;
}
.buttonStyle .btn-secondary:focus {
  background: none;
  color: #1660ab;
  box-shadow: none;
}
.imgStyle button {
  width: 130px;
  border: none;
  border-radius: 4px;
  padding: 4px 4px;
  margin-left: 5px;
  text-transform: uppercase;
  font-family: "Roboto";
  font-size: 11px;
  font-weight: bold;
  color: #5a5a5a;
  background: #323232;
  color: #fff;
}
.imgStyle button:hover {
  background: #191919;
  color: #fff;
}
.imgStyle img {
  margin: 0;
  padding: 0;
  margin-right: 6px;
}
</style>
